'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var reactDom = require('react-dom');
var useTimeout = require('../../../hooks/useTimeout.js');
var Loader = require('../Loader/Loader.js');
var Overlay = require('../../alloy-overlay/Overlay.js');
var loader_module = require('../Loader/loader.module.scss.js');

var DEFAULT_TARGET = 'react-root-page-loader';
var PageLoader = function (_a) {
    var children = _a.children, _b = _a.portalTarget, portalTarget = _b === void 0 ? DEFAULT_TARGET : _b, timeout = _a.timeout, timeoutCallback = _a.timeoutCallback;
    useTimeout.default(timeout, timeoutCallback);
    var ele = document.getElementById(portalTarget);
    return ele
        ? reactDom.createPortal(jsxRuntime.jsxs("div", tslib.__assign({ className: "position-fixed ".concat(loader_module.default['cover'], " ").concat(loader_module.default['preloader']) }, { children: [jsxRuntime.jsx(Overlay.default, { disabled: true }), children ? (jsxRuntime.jsxs("div", tslib.__assign({ className: "".concat(loader_module.default['loader__content'], " bg-white") }, { children: [jsxRuntime.jsx(Loader.default, { className: "text-center" }), jsxRuntime.jsx("div", tslib.__assign({ className: "text-center pt-4" }, { children: children }))] }))) : (jsxRuntime.jsx("div", tslib.__assign({ className: "".concat(loader_module.default['loader__content']) }, { children: jsxRuntime.jsx(Loader.default, { className: "text-center", darkMode: true }) })))] })), ele)
        : null;
};
var PageLoader$1 = PageLoader;

exports.default = PageLoader$1;
//# sourceMappingURL=PageLoader.js.map
